import { Injectable } from '@angular/core';
import { MultiFieldContent } from '@shared/models/multi-field-content';

@Injectable({
	providedIn: 'root'
})
export class MultiFieldTextEditorCacheService {

	// The service keeps the user entered values so they can be filled in
	// when the user switches among different styles configured for multi-field text editor

	constructor() { }

	private keyToContentMap: Map<string, MultiFieldContent> = new Map<string, MultiFieldContent>();
	private formHasBeenDisplayed = false;

	reset(): void {
		this.keyToContentMap.clear();
		this.formHasBeenDisplayed = false;
	}

	getItem(key: string): MultiFieldContent | undefined {
		return this.keyToContentMap.get(key);
	}

	addItem(key: string, field: MultiFieldContent): void {
		this.keyToContentMap.set(key, field);
	}

	
	getFormHasBeenDisplayed(): boolean {
		return this.formHasBeenDisplayed;
	}

	setFormHasBeenDisplayed(hasBeenDisplayed: boolean): void {
		this.formHasBeenDisplayed = hasBeenDisplayed;
	}
}
